// extracted by mini-css-extract-plugin
export default {"footer":"footer-module--footer--10a3b","content":"footer-module--content--2a5fa","contentLanding":"footer-module--contentLanding--e89d4"};